/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

// Local Deps
import './AccountAdmin.scss';
import msgs from '../../config/messages';
import AccountAdminHOC from './AccountAdminHOC';
import AdminMenu from '../../components/AdminMenu';
import ViewUsers from '../../components/ViewUsers';
import AddUser from '../../components/AddUser';
import EditDemographics from '../../components/EditDemographics';
import EditSupplierCaps from '../../components/EditSupplierCaps';
import BidMatchSettings from '../../components/BidMatchSettings';
import Loading from '../../components/Loading';
import UpdateSubscription from '../../components/UpdateSubscription/UpdateSubscription';
import Associations from '../../components/Associations/Association';
import { isFeatureEnabled } from '../../config/featureFlags';

// import ViewTooling from '../ToolingMgmt';
// import AddUser from '../../components/forms/UserForm';
// import AddProduct from '../AddProduct/AddProduct';
// import AddNewPartNumber from '../AddNewPartNum';
// import PartNumberGrid from '../../components/grids/PartNumbers/PartNumbersGrid';

class AccountAdmin extends React.Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    auth: PropTypes.object.isRequired,
    selectedMenu: PropTypes.object,
    onMenuClick: PropTypes.func.isRequired,
    refreshUsers: PropTypes.func.isRequired,
    refreshDemoInitialValues: PropTypes.func.isRequired,
    users: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    demoInitialValues: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      cageCode: PropTypes.string,
      address1: PropTypes.string,
      address2: PropTypes.string,
      address3: PropTypes.string,
      zipCode: PropTypes.string,
      pointofContact: PropTypes.string,
      phoneNumber: PropTypes.string,
      organizationType: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      cntry: PropTypes.string,
      websiteUrl: PropTypes.string,
      subscriptionLevel: PropTypes.string,
    }).isRequired,
    // onCountryChange: PropTypes.func.isRequired,

    orgName: PropTypes.string.isRequired,
    orgCage: PropTypes.string.isRequired,

    // userOrgId: PropTypes.string.isRequired,
    // changeMetaDataBack: PropTypes.func.isRequired,
    organizationsStatus: PropTypes.string.isRequired,
    // onToolFilter: PropTypes.func.isRequired,
    // toolFilter: PropTypes.object.isRequired,
  };

  static defaultProps = {
    selectedMenu: {
      text: 'View and edit Users ',
      value: 'viewusers',
    },
  };

  render() {
    const {
      isLoading,
      auth,
      selectedMenu,
      onMenuClick,
      refreshUsers,
      refreshDemoInitialValues,
      users,
      loading,
      demoInitialValues,
      // onCountryChange,
      orgName,
      orgCage,
      // userOrgId,
      // changeMetaDataBack,
      organizationsStatus,
      // onToolFilter,
      // toolFilter,
    } = this.props;
    const preposition = selectedMenu.value === 'newUser' ? 'for' : 'of';
    return (
      <div className="nf-account-admin">
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Account Admin Page</title>
          <meta name="description" content="description1" />
          <meta name="keywords" content="keyword1,keyword2,keyword3" />
        </Helmet>

        <Row
          className="nf-account-admin__header"
          style={{ flexWrap: 'nowrap', marginRight: 0 }}
        >
          {/* <!-- HEADER --> */}
          <Col xs={3} className="nf-account-admin__side-panel">
            {/* Sidebar placeholder for consistent layout */}
          </Col>
          <Col>
            {!orgName && <h1>{selectedMenu.text}</h1>}
            {orgName && (
              <h1>{`${selectedMenu.text} ${preposition} ${orgName}`}</h1>
            )}
          </Col>
          <Col xs={3} />
        </Row>
        <Row
          style={{
            flexWrap: 'nowrap',
          }}
        >
          <Col xs={2} className="nf-account-admin__side-panel">
            <AdminMenu
              auth={auth}
              onMenuClick={onMenuClick}
              selectedMenu={selectedMenu}
              // onToolFilter={onToolFilter}
            />
          </Col>
          <Col
            style={{
              padding: 0,
            }}
          >
            {/* <!-- LOADING --> */}
            {isLoading && <Loading text={msgs.ViewUsers.loading} />}

            {/* <!-- CONTENT --> */}
            {!isLoading && (
              <div className="nf-account-admin__content">
                <Row className="nf-row--justify-end" />{' '}
                {/* <!-- Admin Caps Grid --> */}
                <div className="nf-account-admin__grid">
                  {selectedMenu.value === 'viewUsers' && (
                    <ViewUsers
                      auth={auth}
                      users={users}
                      loading={loading}
                      refreshUsers={refreshUsers}
                      organizationsStatus={organizationsStatus}
                      orgName={orgName}
                      orgCage={orgCage}
                    />
                  )}

                  {selectedMenu.value === 'newUser' && (
                    <AddUser auth={auth} refreshUsers={refreshUsers} />
                  )}

                  {selectedMenu.value === 'companyDemo' && (
                    <EditDemographics
                      auth={auth}
                      initialValues={demoInitialValues}
                      // onCountryChange={onCountryChange}
                      refreshDemoInitialValues={refreshDemoInitialValues}
                    />
                  )}
                  {selectedMenu.value === 'myCapabilities' && (
                    <EditSupplierCaps auth={auth} />
                  )}
                  {selectedMenu.value === 'remoteAccess' &&
                    isFeatureEnabled('ENABLE_REMOTE_ACCESS') && (
                      <Associations organizationId={auth.organizationId} />
                    )}
                  {selectedMenu.value === 'bidMatch' &&
                    auth.role !== 'GOVERNMENT_USER' && (
                      <BidMatchSettings auth={auth} />
                    )}
                  {selectedMenu.value === 'updateSubscription' &&
                    isFeatureEnabled('ENABLE_BILLSBY') && (
                      <UpdateSubscription
                        auth={auth}
                        initialValues={demoInitialValues}
                      />
                    )}
                  {/* {selectedMenu.value === 'products' && (
                                        <ViewTooling auth={auth} toolFilter={toolFilter} />
                                    )} */}

                  {/* Below 'new uesers'will be put back when we go to one page for all account admin */}
                  {/* {selectedMenu.value === 'newusers' && (<AddUser auth={auth} />)} */}
                  {/* {selectedMenu.value === 'addproduct' && (
                                        <AddProduct auth={auth} />
                                    )} */}

                  {/* {selectedMenu.value === 'viewMyPNs' && (
                                        <PartNumberGrid auth={auth} />
                                    )}
                                    {selectedMenu.value === 'addpartnumber' && (
                                        <AddNewPartNumber auth={auth} />
                                    )} */}

                  {/* {selectedMenu.value !== 'viewusers' &&
                                        selectedMenu.value !== 'newusers' &&
                                        selectedMenu.value !== 'companydemo' &&
                                        selectedMenu.value !== 'myCapabilities' &&
                                        // selectedMenu.value !== 'products' &&
                                        // selectedMenu.value !== 'pendingRequest' &&
                                        // selectedMenu.value !== 'addproduct' &&
                                        // selectedMenu.value !== 'viewMyPNs' &&
                                        // selectedMenu.value !== 'addproduct' && 
                                        <div>TBD</div>} */}
                </div>
              </div>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

export default AccountAdminHOC(AccountAdmin);



// WEBPACK FOOTER //
// ./src/pages/AccountAdmin/AccountAdmin.jsx